import React, { useEffect, useState } from "react";
import api from "./api";
import { useNavigate } from "react-router-dom";

export default function RepertoryDashboard() {

  const [lessons, setLessons] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLessons();
  }, []);

  const fetchLessons = async () => {
    try {
      const res = await api.get("/api/repertory/lessons");
      setLessons(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadLesson = async (lessonId) => {
    try {

      setLoading(true);

      const res = await api.get(
        `/api/repertory/lessons/${lessonId}`
      );

      setSelectedLesson(res.data);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
  <div className="container-fluid py-4 bg-light min-vh-100">

    {/* Header */}
    <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    border: "2px solid red"
  }}
>
       <h2 className="fw-bold text-primary">
        Repertory Dashboard
      </h2>

      <button
  style={{
    background: "green",
    color: "white",
    padding: "10px 20px"
  }}
onClick={() => navigate("/customer/getrepertory")}
>
  Search Rubrics
</button>
    </div>
    {/* Lesson Buttons */}
    <div className="card shadow-sm mb-4">
      <div className="card-body">

        <h5 className="mb-3">
          Chapters
        </h5>

        <div className="d-flex flex-wrap gap-2">

          {lessons.map((lesson) => (

            <button
              key={lesson.id}
              className="btn btn-outline-primary rounded-pill"
              onClick={() => loadLesson(lesson.id)}
            >
              {lesson.name}
            </button>

          ))}

        </div>

      </div>
    </div>

    {loading && (

      <div className="text-center">

        <div
          className="spinner-border text-primary"
          role="status"
        />

      </div>

    )}

    {selectedLesson && (

      <div className="card shadow">

        <div className="card-header bg-primary text-white">

          <h4 className="mb-0">
            {selectedLesson.lessonName}
          </h4>

        </div>

        <div className="card-body">

          {selectedLesson.rubrics.map((rubric) => (

            <RubricNode
              key={rubric.id}
              rubric={rubric}
            />

          ))}

        </div>

      </div>

    )}

  </div>
);
}

/* Recursive Component */
function RubricNode({ rubric }) {

  const [open, setOpen] = useState(true);

  return (
    <div
      className="border-start border-3 ps-3 mt-3"
      style={{
        transition: "all .3s ease"
      }}
    >

      <div
        className="d-flex align-items-center gap-2"
        style={{
          cursor: "pointer"
        }}
        onClick={() => setOpen(!open)}
      >

        <span>

          {open ? "▼" : "▶"}

        </span>

        <h6 className="mb-0 fw-bold text-dark">

          {rubric.name}

        </h6>

      </div>

      {open && (

        <div className="mt-2">

          {rubric.notes && (

            <p className="text-muted small">
              {rubric.notes}
            </p>
          )}
          {rubric.remedies?.length > 0 && (
            <div className="mb-2">
              {rubric.remedies.map((r, index) => (
                <span
                  key={index}
                  className="badge bg-success me-2 mb-2"
                >
                  {r.name}
                  <sup>{r.weight}</sup>
                </span>
              ))}
            </div>
          )}
          {rubric.children?.map((child) => (
            <RubricNode
              key={child.id}
              rubric={child}
            />
          ))}
        </div>
      )}
    </div>
  );
}